import Sprite from "../sprite/Sprite";
import SpriteAnimation from "../sprite/SpriteAnimation";
import ItemType from "./ItemType";

export default class Item {
    /**
     * @param {ItemType} itemType
     * @param {Sprite} iconSprite
     * @param {SpriteAnimation} staticAnimation
     * @param {SpriteAnimation} activeAnimation
     */
    constructor(itemType, iconSprite, staticAnimation, activeAnimation) {
        /**
         * @constant
         * @type {ItemType}
         */
        this.itemType = itemType;
        /**
         * @constant
         * @type {Sprite}
         */
        this.iconSprite = iconSprite;
        /**
         * @constant
         * @type {SpriteAnimation}
         */
        this.staticAnimation = staticAnimation;
        /**
         * @constant
         * @type {SpriteAnimation}
         */
        this.activeAnimation = activeAnimation;

        ////////////////////////////////

        /**
         * @type {boolean}
         */
        this.itemActive = false;
        /**
         * @type {boolean}
         */
        this.itemAnimating = false;

        /**
         * @type {number}
         */
        this.activeAnimationStartTime = 0;
    }

    /**
     * This should be called repeatedly on the character's equipped item to keep it up
     * to date on the active status.
     * @param {boolean} itemActive 
     */
    setItemActive(itemActive) {
        this.itemActive = itemActive;

        if (itemActive) {
            if (!this.itemAnimating) {
                this.activeAnimationStartTime = Date.now();                
                this.itemAnimating = true;
            }
        }
        else {
            // See if we can stop the animation
            if (this.itemAnimating && this.activeAnimation.isAnimationLoopCompleted(this.activeAnimationStartTime)) {
                this.itemAnimating = false;
                this.activeAnimationStartTime = 0;
            }
        }
    }

    /**
     * @returns {Sprite}
     */
    getItemOverlaySprite() {
        if (this.itemActive) {
            return this.activeAnimation.getSpriteAsOf(Date.now(), this.activeAnimationStartTime);
        }
        else if (this.itemAnimating) {
            // The item is not active but there is still an unfinished animation happening.
            if (this.activeAnimation.isAnimationLoopCompleted(this.activeAnimationStartTime)) {
                // We are done animating now.
                this.itemAnimating = false;
            }
            else {
                // Keep displaying the animation until it is finished.
                return this.activeAnimation.getSpriteAsOf(Date.now(), this.activeAnimationStartTime);
            }
        }

        // Show the static item sprite.
        return this.staticAnimation.getSpriteAsOf(Date.now(), this.activeAnimationStartTime);
    }

    /**
     * @returns {boolean}
     */
    isAnimationLoopCompleted() {
        if (this.itemAnimating) {
            return this.activeAnimation.isAnimationLoopCompleted(this.activeAnimationStartTime);
        }

        return true;
    }
}